import React from 'react';

export const SearchIcon = () => {
  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-1,-1.2)">
        <path
          d="M23.129 23.2337L28.9413 29.0881M26.2551 15.6569C26.2551 21.5912 21.4444 26.4019 15.5101 26.4019C9.57583 26.4019 4.76514 21.5912 4.76514 15.6569C4.76514 9.72259 9.57583 4.9119 15.5101 4.9119C21.4444 4.9119 26.2551 9.72259 26.2551 15.6569Z"
          stroke="#353434"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
